<template>
<!-- Main Wrapper -->
        <div class="main-wrapper blank-page">
        
            <!-- Header -->
                <layout-header />
            <!-- /Header -->

            <div class="overflow-hidden bg-light bg-cover bg-no-repeat pb-md-5 pb-4 rounded-none position-relative w-100 features-img"
                :style="'padding-top: 120px;background-position:center;background-image: url('+require('@/assets/img/bg-hero.jpg')+');'">
                <div class="container px-4 py-3 mx-auto position-relative" style="z-index: 1">
                    <h2 class="text-center text-white my-5 display-3 fw-bold">FAQ</h2>
                </div>
            </div>
            
            <!-- Page Content -->
            <div class="content" style="margin-top: 2rem;">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-10 col-xl-9 pb-5">
                            <div class="text-center mb-5 mt-4">
                                <p class="text-muted">
                                    Vous avez des questions ? Nous avons les réponses !<br/>
                                    Consultez notre foire aux questions pour trouver rapidement l'information que vous recherchez.
                                </p>
                            </div>
                            <div class="card mb-3 border-0 faq-box">
                                <div class="card-header faq-header bgc-gray border-0 p-0" style="padding: .5rem 1rem;">
                                    <button class="btn btn-link faq-btn text-left text-primary text-decoration-none w-100 p-3 d-flex justify-content-between align-items-center" data-toggle="collapse" data-target="#faq1" aria-expanded="false">
                                        <span class="text-dark">
                                            <strong>Comment réserver un terrain sur 6v6 ?</strong>
                                        </span>
                                        <i class="material-icons-outlined">add</i>
                                    </button>
                                </div>
                                <div id="faq1" class="collapse">
                                    <div class="card-body border-0">
                                        <p class="text-muted mb-2">Pour réserver un terrain, suivez ces étapes simples :</p>
                                        <ol class="text-muted mb-0">
                                            <li>Créez un compte ou connectez-vous à votre espace personnel</li>
                                            <li>Recherchez un terrain disponible selon votre localisation et vos préférences</li>
                                            <li>Sélectionnez le créneau horaire qui vous convient</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div class="card mb-3 border-0 faq-box">
                                <div class="card-header faq-header bgc-gray border-0 p-0" style="padding: .5rem 1rem;">
                                    <button class="btn btn-link faq-btn text-left text-primary text-decoration-none w-100 p-3 d-flex justify-content-between align-items-center" data-toggle="collapse" data-target="#faq2" aria-expanded="false">
                                        <span class="text-dark">
                                            <strong>Quelle est la politique d'annulation ?</strong>
                                        </span>
                                        <i class="material-icons-outlined">add</i>
                                    </button>
                                </div>
                                <div id="faq2" class="collapse">
                                    <div class="card-body border-0">
                                        <p class="text-muted mb-2">Notre politique d'annulation varie selon les partenaires :</p>
                                        <ul class="text-muted mb-3">
                                            <li><strong>Annulation avant le délai autorisé :</strong> Le montant sera crédité sous forme de bon d'achat</li>
                                            <li><strong>Annulation après le délai :</strong> Aucun remboursement ne sera effectué</li>
                                        </ul>
                                        <div class="alert alert-info mb-0">
                                            <i class="material-icons-outlined align-middle me-2" style="font-size: 18px;">info</i>
                                            Le délai d'annulation est indiqué lors de votre réservation.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>      
            <!-- /Page Content -->

            <!-- Footer -->
                <layout-footer />
            <!-- /Footer -->

            </div>
</template>

<style scoped>
.faq-box {
    box-shadow: none !important;
}
.faq-header {
    border-radius: 50rem !important;
}

.faq-btn {
    border-radius: 50rem;
}

.faq-btn:hover,
.faq-btn:focus {
    text-decoration: none !important;
}
</style>

<script>
export default {
mounted() {
// Content div min height set
    
    function resizeInnerDiv() {
        var height = $(window).height();    
        var header_height = $(".header").height();
        var footer_height = $(".footer").height();
        var breadcrumb_height = $(".breadcrumb-bar").height();
        var setheight = height - breadcrumb_height - header_height;
        var trueheight = setheight - footer_height;
        $(".content").css("min-height", trueheight - 30);
    }
    
    if($('.content').length > 0 ){
        resizeInnerDiv();
    }

    $(window).resize(function(){
        if($('.content').length > 0 ){
            resizeInnerDiv();
        }
    }); 
}
}
</script>
